import { render, staticRenderFns } from "./InstitutionList.vue?vue&type=template&id=2d67905b&"
import script from "./InstitutionList.vue?vue&type=script&lang=js&"
export * from "./InstitutionList.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionList.vue?vue&type=style&index=0&id=2d67905b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports